const FIELD_SCROLL_VERTICAL_OFFSET = 250

export const scrollToElement = (element: HTMLElement) =>
  window.scrollTo({ top: element.offsetTop - FIELD_SCROLL_VERTICAL_OFFSET, behavior: "smooth" })
